import Section from '../Section';
import Swiper from 'swiper';
import { Breakpoints } from '../constants'

export default class TextAdverts extends Section {
    MOBILE_BREAKPOINT = Breakpoints.sm;

    constructor(theme, element, pageLoad) {
      super(theme, element, pageLoad);

      this.element = element;
      this.mobileSlider = this.element.querySelector('.mobile-homepage-text-adverts');
      this.mobileSliderSwiper = null;

      const isMobile = this.theme.getBreakpoint().order <= this.MOBILE_BREAKPOINT.order;
      if (isMobile) {
        this.loadMobileSlider();
      }
      this.theme.loadIcons();
    }

    onBlockSelect = ({ element }) => {
      // Stop animation and show block when select in Text Adverts section on mobile
      if (this.mobileSliderSwiper) {
        var index = Array.prototype.indexOf.call(element.parentElement.children, event.target);
        this.mobileSliderSwiper.autoplay.stop();
        this.mobileSliderSwiper.slideTo(index);
      }
    }

    onBlockDeselect = () => {
      // Resume animation when block is deselected in Text Adverts section on mobile
      if (this.mobileSliderSwiper) {
        this.mobileSliderSwiper.autoplay.start();
      }
    }

    onWindowResizeBreakpoint = ({ breakpoint, oldBreakpoint }) => {
      const newIsMobile = breakpoint.order <= this.MOBILE_BREAKPOINT.order;
      const oldWasMobile = oldBreakpoint.order <= this.MOBILE_BREAKPOINT.order;
      if (newIsMobile !== oldWasMobile) {
        // Switched between mobile and desktop
        if (newIsMobile && !this.mobileSliderSwiper) {
          // Switched from desktop to mobile and mobile slider is not loaded
          this.loadMobileSlider();
        }
      }
    }

    loadMobileSlider = () => {
      const slides = this.mobileSlider.querySelectorAll('.slides li');

      slides.forEach(slide => {
        slide.style.width = this.element.clientWidth;
      });

      const pagination = {
        el: this.mobileSlider.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
        renderBullet: (index, className) => {
          return (
            '<span class="' +
            className +
            '"><span class="swiper-pagination-bullet-dot"></span></span>'
          );
        }
      };

      this.mobileSliderSwiper = new Swiper(this.mobileSlider, {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 20,
        threshold: 10,
        navigation: false,
        pagination: pagination
      });
    }
}
